import classnames from 'classnames/bind'
import { FC } from 'react'
import { useTranslate } from 'react-polyglot'
import { GlobalTextPreset } from '~/@types/text-preset'
import { GlobalTextStyling } from '~/@types/text-styling'

import { useStyle } from '~/providers/StyleProvider'

import { SIZE_GUIDE } from '~/data/dictionary'

import css from './styles.module.scss'

const cx = classnames.bind(css)

interface SizeSwitchProps {
  activeUnit: 'CM' | 'INCH'
  onChange: (unit: 'CM' | 'INCH') => void
}

const SizeSwitch: FC<SizeSwitchProps> = ({ activeUnit, onChange }) => {
  const t = useTranslate()
  const titleStyle = useStyle({
    textPreset: GlobalTextPreset.Label12Haffer,
    textStyling: GlobalTextStyling.UpperCase,
  })

  const buttonLabelStyle = useStyle({
    textPreset: GlobalTextPreset.Cta12Haffer,
    textStyling: GlobalTextStyling.UpperCase,
  })

  return (
    <div className={css.sizeSwitch}>
      <h2 className={titleStyle}>{t(SIZE_GUIDE.SIZE_SWITCHER_TITLE)}</h2>
      <div>
        <button
          className={activeUnit === 'CM' ? css.active : ''}
          onClick={() => onChange('CM')}>
          <p className={buttonLabelStyle}>CM</p>
        </button>
        <button
          className={activeUnit === 'INCH' ? css.active : ''}
          onClick={() => onChange('INCH')}>
          <p className={buttonLabelStyle}>INCHES</p>
        </button>
      </div>
    </div>
  )
}

export default SizeSwitch
